import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSelectedType, selectShowInvalids } from '@store/order/selectors';
import Grid from '@pages/order/patterns/Grid';
import { invalidFormValue } from '@components/utils';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';



interface PatternsProps {
	animalType: AnimalTypeEnum,
}


const Patterns = (props: PatternsProps) => {
	const { animalType } = props;
	const { t } = useTranslation('forms');

	const showInvalids = useSelector(selectShowInvalids);
	const selectedType = useSelector(selectSelectedType);

	return (
		<div className='patterns-section'>

			<label className='patterns-label'>
				{t('patterns.sectionLabel') + ' '}<span>*</span> {showInvalids && invalidFormValue(selectedType) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			<Grid animalType={animalType} />
			
		</div>
	);
};

export default memo(Patterns);